import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "MyTopicsIcon",
  "use": "MyTopicsIcon-usage",
  "viewBox": "0 0 27 14",
  "content": "<symbol viewBox=\"0 0 27 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"MyTopicsIcon\">\n  <path d=\"M24 1H3C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13H24C25.1046 13 26 12.1046 26 11V3C26 1.89543 25.1046 1 24 1Z\" stroke=\"currentColor\" stroke-width=\"1.25\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol